"use client"

import { useState } from "react"
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from "lucide-react"
import "./Footer.css"
import logo from "../../images/imperia-logo.png" // Assuming this path is correct for your logo image

const Footer = () => {
  const [email, setEmail] = useState("")
  const handleSubscribe = (e) => {
    e.preventDefault()
    console.log("Subscribe:", email)
    setEmail("")
  }

const openGoogleMaps = () => {
  const latitude = 28.796718;
  const longitude = 77.077677;
  
  window.open(`https://www.google.com/maps?q=${latitude},${longitude}`, "_blank");
}
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo-container">
              <div className="footer-logo-circle">
                <img src={logo || "/placeholder.svg"} alt="Imperia Hoses Logo" className="footer-logo-img" />
              </div>
              <div className="footer-logo-text-group">
                <div className="footer-logo-main-line">
                  <span className="logo-text-footer">Imperia</span>
                  <span className="logo-accent">Hoses</span>
                </div>
                <span className="footer-tagline">YOUR HOSES PARTNER</span>
              </div>
            </div>
            <p className="footer-tagline-1">Imperia Industries India Pvt. Ltd.</p>
            <p className="footer-description">CIN : U29130DL2016PTC291026</p>
            <div className="social-links">
              <a
                href="https://www.facebook.com/Hydpipe"
                className="social-link"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/imperia_autoparts/?hl=en"
                className="social-link"
                target="_blank"
                aria-label="Instagram"
                rel="noopener noreferrer"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.linkedin.com/company/imperia-industries-india-private-limited/"
                target="_blank"
                className="social-link"
                aria-label="LinkedIn"
                rel="noopener noreferrer"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>
          <div className="footer-section">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li>
                <a href="/company">Company</a>
              </li>
              <li>
                <a href="/products">Products & Solution</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
              <li>
                <a href="/news">News & Exhibition</a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h3 className="footer-title">Contact Us</h3>
            <p className="contact-description">
              We are always open to discuss your requirements, improve your vehicle performance and help with your fluid
              transmission challenges.
              <br /> Any developments & requirements related to Hoses & Tubes.
            </p>
            <div className="contact-items-row">
              <a href="tel:+919350019570" className="contact-item">
                <Phone size={16} />
                <span>+91 9350019570</span>
              </a>
              <a href="mailto:imperiahoses@gmail.com" className="contact-item">
                <Mail size={16} />
                <span>imperiahoses@gmail.com</span>
              </a>
              <div className="contact-item" onClick={openGoogleMaps} style={{ cursor: 'pointer' }}>
                <MapPin size={16} />
                <span>Delhi, India</span>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="footer-bottom-content">
              <p>&copy; 2025 Imperia Industries India Pvt. Ltd. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
export default Footer